import { Box } from '@mui/material';

import { ComponentErrorBoundary } from '@/components';
import { MobileFilterDrawer } from './MobileFilterDrawer';
import { SearchPageResults } from './SearchPageResults';
import { SearchSidebar } from './SearchSidebar';

import type { BrowseFilter } from '@/constants';

interface SearchPageLayoutProps {
  searchQuery: string;
  status: string;
  searchInputRef: React.RefObject<HTMLDivElement>;
  handleBrowseClick: (filter: BrowseFilter) => void;
  handleSearchChange: (value: string) => void;
  handleStatusChange: (status: string) => void;
  handleClearFilters: () => void;
}

export function SearchPageLayout({
  searchQuery,
  status,
  searchInputRef,
  handleBrowseClick,
  handleSearchChange,
  handleStatusChange,
  handleClearFilters,
}: SearchPageLayoutProps) {
  return (
    <>
      <ComponentErrorBoundary componentName="SearchPageLayout">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
            justifyContent: 'space-between',
            gap: { xs: 3, md: 2 },
            minHeight: { xs: 'auto', lg: '30rem' },
          }}
        >
          {/* Main Content */}
          <SearchPageResults
            searchQuery={searchQuery}
            status={status}
            searchInputRef={searchInputRef}
            handleBrowseClick={handleBrowseClick}
            handleStatusChange={handleStatusChange}
            handleClearFilters={handleClearFilters}
          />

          {/* Desktop Sidebar (hidden on mobile) */}
          <Box sx={{ display: { xs: 'none', lg: 'block' }, width: { lg: '30%' } }}>
            <SearchSidebar
              searchQuery={searchQuery}
              status={status}
              searchInputRef={searchInputRef}
              onSearchChange={handleSearchChange}
              onStatusChange={handleStatusChange}
              onClearFilters={handleClearFilters}
            />
          </Box>
        </Box>

        {/* Mobile FAB and Drawer Filter Component */}
        <MobileFilterDrawer
          status={status}
          onStatusChange={handleStatusChange}
          onBrowseClick={handleBrowseClick}
          onClearFilters={handleClearFilters}
        />
      </ComponentErrorBoundary>
    </>
  );
}
